<template lang="pug">
  #app.main-layout.auth-layout
    section
      e-error(v-if="error" :error="error")
      router-view(v-else)
</template>
<script>
  export default {
    name: 'auth-layout',
    computed: {
      error () {
        return this.$store.getters.getError
      }
    }
  }
</script>
